import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import AntTag from 'antd/lib/tag';
import './style';

const propTypes = {
  color: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  outline: PropTypes.bool,
  ...AntTag.propType,
};

const defaultProps = {
  outline: true,
  ...AntTag.defaultProps,
};


function Tag({
  className, color, outline, children, ...rest
}) {
  let tagColorStyle;
  if (color && color.indexOf('#') >= 0) {
    tagColorStyle = {
      style: {
        color,
        backgroundColor: 'transparent',
        borderColor: color,
      },
    };
  }
  const tagClass = classnames('bsa-tag', {
    'bsa-tag--no-bordered': !outline,
    'bsa-tag--green': color === 'green',
    'bsa-tag--red': color === 'red',
    'bsa-tag--dark-red': color === 'darkRed',
    'bsa-tag--orange': color === 'orange',
    'bsa-tag--gray': color === 'gray',
    'bsa-tag--yellow': color === 'yellow',
  }, className);

  return (
    <AntTag className={tagClass} {...tagColorStyle} {...rest}>
      {children}
    </AntTag>
  );
}

Tag.defaultProps = defaultProps;
Tag.propTypes = propTypes;
Tag.CheckableTag = AntTag.CheckableTag;
export default Tag;
